<template>
  <div>
    <list
      :columns="columns"
      :modalCreate="modalCreate"
      :removeLink="removeLink"
      :cardLink="cardLink"
      :isUpdate="false"
      :isAdd="!true"
      :isMoveto="true"
      :itemLink="itemLink"
      :setLink="setLink"
      :openItem="true"
      :fields="fields"
      fieldClass="col-md-4"
      :searchDisable="true"
      @change="change"
      @changeFunction="changeFunction"
      v-model="val"
    />
  </div>
</template>
<script>
export default {
  name: "products",
  props:['id'],
  created(){
    this.itemLink = `business/groups/${this.id}/courses`;
    // this.setLink = `business/groups/${this.id}/courses`;
    this.setLink = `${process.env.HOST_URL}/api/v3/schools/${this.$store.state.business.id}/classes/${this.id}/move-to-next-year`;
  },
  methods: {
    changeFunction(val) {},
    change(val) {},
  
  },
  data() {
    return {
      val: [],
      modalCreate: "course_group",
      fields: [

     {
          col: 'col-12 col-md-6',
          label: "Выберите номер класса",
          key: "course_id",
          type: "course",

        },
          // {
          //     key: "title",
          //     label: "Буква класса",
          //     type: "field",
          //     textType: "text",
          //     col:'col-12 col-md-6',
          // },
      
          {
              col:'col-12 col-md-6',
              label: "Сезон",
              key: "season",
              type: "select",
              selectKey: "title",
              modal: "season",
              prefix: "season_group_cource",
          },
      ],
      /** APIs */
      removeLink: "",
      // cardLink: "item_group_course",
      cardLink: "item_group_course",
      itemLink: "groups",
      setLink: `${process.env.HOST_URL}/api/v3/schools/${this.$store.state.business.id}/classes/${this.id}/move-to-next-year`,
      columns: [
          {
            key: "course",
            title: "Номер курса",
            checkbox: false,
            disableLink: true,
            object: 'title',
          },
          {
              key: "title",
              title: "Название (Буква)",
              checkbox: false,
              control: false,
              align: "left",
              timer: false,
              detail: false,
          },
          {
              key: "season",
              title: "Учебный год",
              checkbox: false,
              disableLink: true,
              object: 'title',
          },
          {
              detail: true,
              remove: true,
          },
      ],
    };
  },
};
</script>
<style>
</style>
